import { useContext } from "react";
import { CircleMarker, MapContainer, TileLayer } from "react-leaflet";
import { useEffect, useState } from "react";
import config from "../../config";
import { getUserToken } from "../../contexts/AuthContext";
import { NotificationContext } from "../../contexts/NotificationContext";
import { ContinentContext } from "../../pages/ContinentWrapper";
import { roundTo } from "../../util/Format";
import { LeafletHandler } from "../../util/Map";
import EditRow from "../EditRow";

function ContinentMap() {
    const [continent, setContinent] = useContext(ContinentContext);
    const { addNotification } = useContext(NotificationContext);
    const [center, setCenter] = useState({lat: null, lon: null});
    const [zoom, setZoom] = useState(null);
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        setCenter({ lat: continent.latitude, lng: continent.longitude });
        setZoom(continent.zoom);
    }, [continent]);

    function changeCenter(latlng) {
        if (editing) {
            setCenter(latlng);
        }
    }

    async function updateContinent() {
        const token = await getUserToken();
        const res = await fetch(`${config.geoid_url_v3}/v2/Continent/Coordinate/${continent.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                latitude: Number(roundTo(center.lat, 6)),
                longitude: Number(roundTo(center.lng, 6)),
                zoom: Number(roundTo(zoom, 1))
            })
        });

        if (res.status === 200) {
            let copy = { ...continent };
            copy.latitude = Number(roundTo(center.lat, 6));
            copy.longitude = Number(roundTo(center.lng, 6));
            copy.zoom = Number(roundTo(zoom, 1));

            setContinent(copy);
            setEditing(false);
            addNotification('Continent was editted successfully', 'SUCCESS');
        } else {
            const result = await res.json();
            addNotification(result.message, 'ERROR');
        }
    }

    if (continent) {
        return (
            <section className="bg-white shadow overflow-hidden rounded-lg flex full-w flex-col my-6">
                <div className="flex items-center justify-between px-4 py-5 sm:px-6">
                    <div>
                        <div className="flex items-center">
                            <h2 className="text-2xl font-bold text-gray-900">
                                Map center and zoom
                            </h2>

                            <div className="flex ml-4">
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                    Lat {roundTo(center.lat, 6)}, Long {roundTo(center.lng, 6)}
                                </span>

                                {!editing && <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                    Zoom {roundTo(continent.zoom, 1)}
                                </span>}

                                {editing && <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                    Zoom {roundTo(zoom, 1)}
                                </span>}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-center">
                        <EditRow
                            cancel={true}
                            buttonText="Save"
                            editState={editing}
                            save={() => { updateContinent() }}
                            editing={(state) => { setEditing(state) }} />
                    </div>
                </div>

                <div className="block h-half z-0">
                    <MapContainer center={[continent.latitude, continent.longitude]} zoom={continent.zoom} zoomSnap={0.1} zoomDelta={0.1}>
                        <TileLayer
                            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors - &copy; <a href="https://maptiler.com/copyright">MapTiler</a>'
                            url="https://maps.meteoplaza.com/styles/topo/{z}/{x}/{y}.png" />

                        {center && <CircleMarker
                            center={center}
                            pathOptions={{ color: 'black' }}
                            radius={10}>
                        </CircleMarker>}

                        <LeafletHandler newCenter={(latlng) => changeCenter(latlng)} newZoom={(zoom) => setZoom(zoom)} />
                    </MapContainer>
                </div>
            </section>
        )
    } else {
        return null;
    }
}

export default ContinentMap;